const initModals = function initModals()
{
  const modals = document.querySelectorAll('.modals__link');

  if( modals.length > 0 ) {
    modals.forEach( (item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = item.attributes.href.value.replace('#', '');
        const modal = document.getElementById(modalId);
        const activeModal = document.querySelector('.modal-item.active');
        if ( activeModal ) {
          activeModal.classList.remove('active');
        }
        if ( modal ) {
          modal.classList.add('active');
        }
      });
    });
  }
}
export { initModals };